export default "__VITE_ASSET__CSvHqyAX__"